import { Box } from '@mui/material';
import {
    DataGridPro,
    DataGridProProps,
    GridColDef,
    GridRenderCellParams,
    GridValueGetterParams,
} from '@mui/x-data-grid-pro';
import React from 'react';

import { RequestStatus } from 'app/components/request-status';
import { Translate } from 'app/components/translate';
import { SeamRequest } from 'app/model';
import { DataGridFormatters } from 'app/utils/data-grid-formatters';
import { Formatters } from 'app/utils/formatters';
import { Strings } from 'app/utils/strings';

interface RequestListGridProps extends Omit<DataGridProProps, 'columns'> {
    rows: SeamRequest[];
    /**
     * Extra columns to prepend to the default ones
     */
    startColumns?: GridColDef[];
    /**
     * Extra columns to append to the default ones
     */
    endColumns?: GridColDef[];
}

export class RequestListGrid extends React.Component<RequestListGridProps> {
    public render(): React.ReactNode {
        const { startColumns, endColumns, ...props } = this.props;

        const allCols = [...(startColumns || []), ...columns, ...(endColumns || [])];

        return (
            <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
                <DataGridPro {...props} columns={allCols} />
            </Box>
        );
    }
}

const columns: Array<GridColDef<SeamRequest>> = [
    {
        field: 'id',
        headerName: 'ID',
        width: 180,
        disableColumnMenu: true,
        renderCell: (params: GridRenderCellParams<SeamRequest, SeamRequest['id']>) => {
            const tKey = `headings:${Strings.seamRequestType(params.row)}`;
            const seamId = Formatters.seamRequestId(params.value);

            return (
                <span>
                    {seamId} (<Translate tkey={tKey} />)
                </span>
            );
        },
    },
    {
        field: 'currentPlace',
        headerName: 'Status',
        width: 200,
        renderCell: (data: GridRenderCellParams<SeamRequest, SeamRequest['currentPlace']>) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            <RequestStatus status={data.value!} />
        ),
    },
    {
        field: 'store',
        headerName: 'Store',
        width: 250,
        valueGetter: (params: GridValueGetterParams<SeamRequest, SeamRequest['store']>) => params.value?.name,
    },
    {
        field: 'brand',
        headerName: 'Brand',
        width: 150,
        valueGetter: (params) => params.row.store.brand?.name,
    },
    {
        field: 'dueDate',
        headerName: 'Due Date',
        width: 120,
        disableColumnMenu: true,
        valueFormatter: DataGridFormatters.dateFormatter,
    },
    {
        field: 'owner',
        headerName: 'Assignee',
        width: 150,
        disableColumnMenu: true,
        valueFormatter: DataGridFormatters.usernameFormatter,
    },
    {
        field: 'manager',
        headerName: 'Manager',
        width: 150,
        disableColumnMenu: true,
        valueFormatter: DataGridFormatters.usernameFormatter,
    },
];
